"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useErrorTouched = void 0;
var _react = require("react");
const useErrorTouched = error => {
  const [touched, setTouched] = (0, _react.useState)(!error);
  (0, _react.useEffect)(() => {
    if (error) setTouched(false);
  }, [error]);
  const onTouch = () => {
    setTouched(true);
  };
  return [touched, onTouch];
};
exports.useErrorTouched = useErrorTouched;